import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { useBoolean } from '@fluentui/react-hooks';
import ChecklistDashboardTable from '../Components/ChecklistDashboardTable';
import DeleteModal from "../../../../Util/DeleteModal";
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedCobrandId, setSelectedCobrandId] = useState(undefined);
    const [selectedCobrandName, setSelectedCobrandName] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const history = useHistory();
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: configs, loading }, refetch] = useAxios("/internal/checklist-dashboard/list");

    if (loading) return <Spinner className="absolute-center" label="Loading Checklist Dashboards..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Checklist Dashboard disabled."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <ChecklistDashboardTable
                configs={configs}
                loading={loading}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, cobrandName) => {
                    setSelectedCobrandId(id);
                    setSelectedCobrandName(cobrandName || "");
                    toggleDeleteModal();
                }}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`internal/checklist-dashboard/${selectedCobrandId}`}
                resourceName={selectedCobrandName}
                resourceType="checklist dashboard"
                deleteButtonText="Disable"
                confirmationValue={selectedCobrandName || undefined}
            />
        </>
    );
};

export default DefaultPage;
